import * as React from 'react';
import { observer } from 'mobx-react';
import { createGlobalStyle } from 'styled-components';
import { AssetStore } from './stores';
import { computed } from 'mobx';

const fontFamilies = [
    'HeaderFont',
    'BodyFont',
    'FontLight',
    'FontLightItalic',
    'FontThin',
    'FontThinItalic',
    'FontMedium',
    'FontMediumItalic',
    'FontRegular',
    'FontItalic',
    'FontSemiBold',
    'FontSemiBoldItalic',
    'FontBold',
    'FontBoldItalic',
    'FontBlack',
    'FontBlackItalic',
];

interface GlobalStylesProps {
    assetStore?: AssetStore;
    children?: any;
}

@observer
class GlobalFontStyles extends React.Component<GlobalStylesProps> {
    @computed
    get fontFaces(): string {
        /*
         * Generate @font-face for fonts.
         * To make use of a particular font, upload a font file named e.g. "FontLight.ttf" to application assets,
         * then reference it in styles by font-family name e.g. "FontLight".
         * Fonts not referenced in styles will not be downloaded.
         */
        const { props } = this as any;
        if (props) {
            const { assetStore } = props;
            return `
                ${fontFamilies.map(font => {
                    return `@font-face {
                                font-family: '${font}';
                                src: url('${assetStore.getAssetUrl(
                                    `${font}.ttf`
                                )}');
                                font-display: fallback;
                            }`;
                })}
        `;
        }
    }

    get StyledGlobalStyles() {
        return createGlobalStyle`${this.fontFaces}`;
    }

    // We need to put the fonts in the <head> so that the browser can detect
    // and download the fonts to use in the shadowDOM
    setHeadFontStyles() {
        const css = this.fontFaces;
        const head = document.head || document.getElementsByTagName('head')[0];
        const style = document.createElement('style');

        head.appendChild(style);
        style.appendChild(document.createTextNode(css));
    }

    render() {
        const { assetStore } = this.props;
        this.setHeadFontStyles();
        const StyledGlobalStyles = this.StyledGlobalStyles;
        return <StyledGlobalStyles assetStore={assetStore} />;
    }
}

export default GlobalFontStyles;



// WEBPACK FOOTER //
// ./src/GlobalFontStyles.tsx